export const iconsSolid = [
  {
    prefix: "fas",
    name: "ad",
  },
  {
    prefix: "fas",
    name: "address-book",
  },
  {
    prefix: "fas",
    name: "address-card",
  },
  {
    prefix: "fas",
    name: "adjust",
  },
  {
    prefix: "fas",
    name: "air-freshener",
  },
  {
    prefix: "fas",
    name: "align-center",
  },
  {
    prefix: "fas",
    name: "align-justify",
  },
  {
    prefix: "fas",
    name: "align-left",
  },
  {
    prefix: "fas",
    name: "align-right",
  },
  {
    prefix: "fas",
    name: "allergies",
  },
  {
    prefix: "fas",
    name: "ambulance",
  },
  {
    prefix: "fas",
    name: "american-sign-language-interpreting",
  },
  {
    prefix: "fas",
    name: "anchor",
  },
  {
    prefix: "fas",
    name: "angle-double-down",
  },
  {
    prefix: "fas",
    name: "angle-double-left",
  },
  {
    prefix: "fas",
    name: "angle-double-right",
  },
  {
    prefix: "fas",
    name: "angle-double-up",
  },
  {
    prefix: "fas",
    name: "angle-down",
  },
  {
    prefix: "fas",
    name: "angle-left",
  },
  {
    prefix: "fas",
    name: "angle-right",
  },
  {
    prefix: "fas",
    name: "angle-up",
  },
  {
    prefix: "fas",
    name: "angry",
  },
  {
    prefix: "fas",
    name: "ankh",
  },
  {
    prefix: "fas",
    name: "apple-alt",
  },
  {
    prefix: "fas",
    name: "archive",
  },
  {
    prefix: "fas",
    name: "archway",
  },
  {
    prefix: "fas",
    name: "arrow-alt-circle-down",
  },
  {
    prefix: "fas",
    name: "arrow-alt-circle-left",
  },
  {
    prefix: "fas",
    name: "arrow-alt-circle-right",
  },
  {
    prefix: "fas",
    name: "arrow-alt-circle-up",
  },
  {
    prefix: "fas",
    name: "arrow-circle-down",
  },
  {
    prefix: "fas",
    name: "arrow-circle-left",
  },
  {
    prefix: "fas",
    name: "arrow-circle-right",
  },
  {
    prefix: "fas",
    name: "arrow-circle-up",
  },
  {
    prefix: "fas",
    name: "arrow-down",
  },
  {
    prefix: "fas",
    name: "arrow-left",
  },
  {
    prefix: "fas",
    name: "arrow-right",
  },
  {
    prefix: "fas",
    name: "arrow-up",
  },
  {
    prefix: "fas",
    name: "arrows-alt",
  },
  {
    prefix: "fas",
    name: "arrows-alt-h",
  },
  {
    prefix: "fas",
    name: "arrows-alt-v",
  },
  {
    prefix: "fas",
    name: "assistive-listening-systems",
  },
  {
    prefix: "fas",
    name: "asterisk",
  },
  {
    prefix: "fas",
    name: "at",
  },
  {
    prefix: "fas",
    name: "atlas",
  },
  {
    prefix: "fas",
    name: "atom",
  },
  {
    prefix: "fas",
    name: "audio-description",
  },
  {
    prefix: "fas",
    name: "award",
  },
  {
    prefix: "fas",
    name: "baby",
  },
  {
    prefix: "fas",
    name: "baby-carriage",
  },
  {
    prefix: "fas",
    name: "backspace",
  },
  {
    prefix: "fas",
    name: "backward",
  },
  {
    prefix: "fas",
    name: "bacon",
  },
  {
    prefix: "fas",
    name: "bacteria",
  },
  {
    prefix: "fas",
    name: "bacterium",
  },
  {
    prefix: "fas",
    name: "bahai",
  },
  {
    prefix: "fas",
    name: "balance-scale",
  },
  {
    prefix: "fas",
    name: "balance-scale-left",
  },
  {
    prefix: "fas",
    name: "balance-scale-right",
  },
  {
    prefix: "fas",
    name: "ban",
  },
  {
    prefix: "fas",
    name: "band-aid",
  },
  {
    prefix: "fas",
    name: "barcode",
  },
  {
    prefix: "fas",
    name: "bars",
  },
  {
    prefix: "fas",
    name: "baseball-ball",
  },
  {
    prefix: "fas",
    name: "basketball-ball",
  },
  {
    prefix: "fas",
    name: "bath",
  },
  {
    prefix: "fas",
    name: "battery-empty",
  },
  {
    prefix: "fas",
    name: "battery-full",
  },
  {
    prefix: "fas",
    name: "battery-half",
  },
  {
    prefix: "fas",
    name: "battery-quarter",
  },
  {
    prefix: "fas",
    name: "battery-three-quarters",
  },
  {
    prefix: "fas",
    name: "bed",
  },
  {
    prefix: "fas",
    name: "beer",
  },
  {
    prefix: "fas",
    name: "bell",
  },
  {
    prefix: "fas",
    name: "bell-slash",
  },
  {
    prefix: "fas",
    name: "bezier-curve",
  },
  {
    prefix: "fas",
    name: "bible",
  },
  {
    prefix: "fas",
    name: "bicycle",
  },
  {
    prefix: "fas",
    name: "biking",
  },
  {
    prefix: "fas",
    name: "binoculars",
  },
  {
    prefix: "fas",
    name: "biohazard",
  },
  {
    prefix: "fas",
    name: "birthday-cake",
  },
  {
    prefix: "fas",
    name: "blender",
  },
  {
    prefix: "fas",
    name: "blender-phone",
  },
  {
    prefix: "fas",
    name: "blind",
  },
  {
    prefix: "fas",
    name: "blog",
  },
  {
    prefix: "fas",
    name: "bold",
  },
  {
    prefix: "fas",
    name: "bolt",
  },
  {
    prefix: "fas",
    name: "bomb",
  },
  {
    prefix: "fas",
    name: "bone",
  },
  {
    prefix: "fas",
    name: "bong",
  },
  {
    prefix: "fas",
    name: "book",
  },
  {
    prefix: "fas",
    name: "book-dead",
  },
  {
    prefix: "fas",
    name: "book-medical",
  },
  {
    prefix: "fas",
    name: "book-open",
  },
  {
    prefix: "fas",
    name: "book-reader",
  },
  {
    prefix: "fas",
    name: "bookmark",
  },
  {
    prefix: "fas",
    name: "border-all",
  },
  {
    prefix: "fas",
    name: "border-none",
  },
  {
    prefix: "fas",
    name: "border-style",
  },
  {
    prefix: "fas",
    name: "bowling-ball",
  },
  {
    prefix: "fas",
    name: "box",
  },
  {
    prefix: "fas",
    name: "box-open",
  },
  {
    prefix: "fas",
    name: "box-tissue",
  },
  {
    prefix: "fas",
    name: "boxes",
  },
  {
    prefix: "fas",
    name: "braille",
  },
  {
    prefix: "fas",
    name: "brain",
  },
  {
    prefix: "fas",
    name: "bread-slice",
  },
  {
    prefix: "fas",
    name: "briefcase",
  },
  {
    prefix: "fas",
    name: "briefcase-medical",
  },
  {
    prefix: "fas",
    name: "broadcast-tower",
  },
  {
    prefix: "fas",
    name: "broom",
  },
  {
    prefix: "fas",
    name: "brush",
  },
  {
    prefix: "fas",
    name: "bug",
  },
  {
    prefix: "fas",
    name: "building",
  },
  {
    prefix: "fas",
    name: "bullhorn",
  },
  {
    prefix: "fas",
    name: "bullseye",
  },
  {
    prefix: "fas",
    name: "burn",
  },
  {
    prefix: "fas",
    name: "bus",
  },
  {
    prefix: "fas",
    name: "bus-alt",
  },
  {
    prefix: "fas",
    name: "business-time",
  },
  {
    prefix: "fas",
    name: "calculator",
  },
  {
    prefix: "fas",
    name: "calendar",
  },
  {
    prefix: "fas",
    name: "calendar-alt",
  },
  {
    prefix: "fas",
    name: "calendar-check",
  },
  {
    prefix: "fas",
    name: "calendar-day",
  },
  {
    prefix: "fas",
    name: "calendar-minus",
  },
  {
    prefix: "fas",
    name: "calendar-plus",
  },
  {
    prefix: "fas",
    name: "calendar-times",
  },
  {
    prefix: "fas",
    name: "calendar-week",
  },
  {
    prefix: "fas",
    name: "camera",
  },
  {
    prefix: "fas",
    name: "camera-retro",
  },
  {
    prefix: "fas",
    name: "campground",
  },
  {
    prefix: "fas",
    name: "candy-cane",
  },
  {
    prefix: "fas",
    name: "cannabis",
  },
  {
    prefix: "fas",
    name: "capsules",
  },
  {
    prefix: "fas",
    name: "car",
  },
  {
    prefix: "fas",
    name: "car-alt",
  },
  {
    prefix: "fas",
    name: "car-battery",
  },
  {
    prefix: "fas",
    name: "car-crash",
  },
  {
    prefix: "fas",
    name: "car-side",
  },
  {
    prefix: "fas",
    name: "caravan",
  },
  {
    prefix: "fas",
    name: "caret-down",
  },
  {
    prefix: "fas",
    name: "caret-left",
  },
  {
    prefix: "fas",
    name: "caret-right",
  },
  {
    prefix: "fas",
    name: "caret-square-down",
  },
  {
    prefix: "fas",
    name: "caret-square-left",
  },
  {
    prefix: "fas",
    name: "caret-square-right",
  },
  {
    prefix: "fas",
    name: "caret-square-up",
  },
  {
    prefix: "fas",
    name: "caret-up",
  },
  {
    prefix: "fas",
    name: "carrot",
  },
  {
    prefix: "fas",
    name: "cart-arrow-down",
  },
  {
    prefix: "fas",
    name: "cart-plus",
  },
  {
    prefix: "fas",
    name: "cash-register",
  },
  {
    prefix: "fas",
    name: "cat",
  },
  {
    prefix: "fas",
    name: "certificate",
  },
  {
    prefix: "fas",
    name: "chair",
  },
  {
    prefix: "fas",
    name: "chalkboard",
  },
  {
    prefix: "fas",
    name: "chalkboard-teacher",
  },
  {
    prefix: "fas",
    name: "charging-station",
  },
  {
    prefix: "fas",
    name: "chart-area",
  },
  {
    prefix: "fas",
    name: "chart-bar",
  },
  {
    prefix: "fas",
    name: "chart-line",
  },
  {
    prefix: "fas",
    name: "chart-pie",
  },
  {
    prefix: "fas",
    name: "check",
  },
  {
    prefix: "fas",
    name: "check-circle",
  },
  {
    prefix: "fas",
    name: "check-double",
  },
  {
    prefix: "fas",
    name: "check-square",
  },
  {
    prefix: "fas",
    name: "cheese",
  },
  {
    prefix: "fas",
    name: "chess",
  },
  {
    prefix: "fas",
    name: "chess-bishop",
  },
  {
    prefix: "fas",
    name: "chess-board",
  },
  {
    prefix: "fas",
    name: "chess-king",
  },
  {
    prefix: "fas",
    name: "chess-knight",
  },
  {
    prefix: "fas",
    name: "chess-pawn",
  },
  {
    prefix: "fas",
    name: "chess-queen",
  },
  {
    prefix: "fas",
    name: "chess-rook",
  },
  {
    prefix: "fas",
    name: "chevron-circle-down",
  },
  {
    prefix: "fas",
    name: "chevron-circle-left",
  },
  {
    prefix: "fas",
    name: "chevron-circle-right",
  },
  {
    prefix: "fas",
    name: "chevron-circle-up",
  },
  {
    prefix: "fas",
    name: "chevron-down",
  },
  {
    prefix: "fas",
    name: "chevron-left",
  },
  {
    prefix: "fas",
    name: "chevron-right",
  },
  {
    prefix: "fas",
    name: "chevron-up",
  },
  {
    prefix: "fas",
    name: "child",
  },
  {
    prefix: "fas",
    name: "church",
  },
  {
    prefix: "fas",
    name: "circle",
  },
  {
    prefix: "fas",
    name: "circle-notch",
  },
  {
    prefix: "fas",
    name: "city",
  },
  {
    prefix: "fas",
    name: "clinic-medical",
  },
  {
    prefix: "fas",
    name: "clipboard",
  },
  {
    prefix: "fas",
    name: "clipboard-check",
  },
  {
    prefix: "fas",
    name: "clipboard-list",
  },
  {
    prefix: "fas",
    name: "clock",
  },
  {
    prefix: "fas",
    name: "clone",
  },
  {
    prefix: "fas",
    name: "closed-captioning",
  },
  {
    prefix: "fas",
    name: "cloud",
  },
  {
    prefix: "fas",
    name: "cloud-download-alt",
  },
  {
    prefix: "fas",
    name: "cloud-meatball",
  },
  {
    prefix: "fas",
    name: "cloud-moon",
  },
  {
    prefix: "fas",
    name: "cloud-moon-rain",
  },
  {
    prefix: "fas",
    name: "cloud-rain",
  },
  {
    prefix: "fas",
    name: "cloud-showers-heavy",
  },
  {
    prefix: "fas",
    name: "cloud-sun",
  },
  {
    prefix: "fas",
    name: "cloud-sun-rain",
  },
  {
    prefix: "fas",
    name: "cloud-upload-alt",
  },
  {
    prefix: "fas",
    name: "cocktail",
  },
  {
    prefix: "fas",
    name: "code",
  },
  {
    prefix: "fas",
    name: "code-branch",
  },
  {
    prefix: "fas",
    name: "coffee",
  },
  {
    prefix: "fas",
    name: "cog",
  },
  {
    prefix: "fas",
    name: "cogs",
  },
  {
    prefix: "fas",
    name: "coins",
  },
  {
    prefix: "fas",
    name: "columns",
  },
  {
    prefix: "fas",
    name: "comment",
  },
  {
    prefix: "fas",
    name: "comment-alt",
  },
  {
    prefix: "fas",
    name: "comment-dollar",
  },
  {
    prefix: "fas",
    name: "comment-dots",
  },
  {
    prefix: "fas",
    name: "comment-medical",
  },
  {
    prefix: "fas",
    name: "comment-slash",
  },
  {
    prefix: "fas",
    name: "comments",
  },
  {
    prefix: "fas",
    name: "comments-dollar",
  },
  {
    prefix: "fas",
    name: "compact-disc",
  },
  {
    prefix: "fas",
    name: "compass",
  },
  {
    prefix: "fas",
    name: "compress",
  },
  {
    prefix: "fas",
    name: "compress-alt",
  },
  {
    prefix: "fas",
    name: "compress-arrows-alt",
  },
  {
    prefix: "fas",
    name: "concierge-bell",
  },
  {
    prefix: "fas",
    name: "cookie",
  },
  {
    prefix: "fas",
    name: "cookie-bite",
  },
  {
    prefix: "fas",
    name: "copy",
  },
  {
    prefix: "fas",
    name: "copyright",
  },
  {
    prefix: "fas",
    name: "couch",
  },
  {
    prefix: "fas",
    name: "credit-card",
  },
  {
    prefix: "fas",
    name: "crop",
  },
  {
    prefix: "fas",
    name: "crop-alt",
  },
  {
    prefix: "fas",
    name: "cross",
  },
  {
    prefix: "fas",
    name: "crosshairs",
  },
  {
    prefix: "fas",
    name: "crow",
  },
  {
    prefix: "fas",
    name: "crown",
  },
  {
    prefix: "fas",
    name: "crutch",
  },
  {
    prefix: "fas",
    name: "cube",
  },
  {
    prefix: "fas",
    name: "cubes",
  },
  {
    prefix: "fas",
    name: "cut",
  },
  {
    prefix: "fas",
    name: "database",
  },
  {
    prefix: "fas",
    name: "deaf",
  },
  {
    prefix: "fas",
    name: "democrat",
  },
  {
    prefix: "fas",
    name: "desktop",
  },
  {
    prefix: "fas",
    name: "dharmachakra",
  },
  {
    prefix: "fas",
    name: "diagnoses",
  },
  {
    prefix: "fas",
    name: "dice",
  },
  {
    prefix: "fas",
    name: "dice-d20",
  },
  {
    prefix: "fas",
    name: "dice-d6",
  },
  {
    prefix: "fas",
    name: "dice-five",
  },
  {
    prefix: "fas",
    name: "dice-four",
  },
  {
    prefix: "fas",
    name: "dice-one",
  },
  {
    prefix: "fas",
    name: "dice-six",
  },
  {
    prefix: "fas",
    name: "dice-three",
  },
  {
    prefix: "fas",
    name: "dice-two",
  },
  {
    prefix: "fas",
    name: "digital-tachograph",
  },
  {
    prefix: "fas",
    name: "directions",
  },
  {
    prefix: "fas",
    name: "disease",
  },
  {
    prefix: "fas",
    name: "divide",
  },
  {
    prefix: "fas",
    name: "dizzy",
  },
  {
    prefix: "fas",
    name: "dna",
  },
  {
    prefix: "fas",
    name: "dog",
  },
  {
    prefix: "fas",
    name: "dollar-sign",
  },
  {
    prefix: "fas",
    name: "dolly",
  },
  {
    prefix: "fas",
    name: "dolly-flatbed",
  },
  {
    prefix: "fas",
    name: "donate",
  },
  {
    prefix: "fas",
    name: "door-closed",
  },
  {
    prefix: "fas",
    name: "door-open",
  },
  {
    prefix: "fas",
    name: "dot-circle",
  },
  {
    prefix: "fas",
    name: "dove",
  },
  {
    prefix: "fas",
    name: "download",
  },
  {
    prefix: "fas",
    name: "drafting-compass",
  },
  {
    prefix: "fas",
    name: "dragon",
  },
  {
    prefix: "fas",
    name: "draw-polygon",
  },
  {
    prefix: "fas",
    name: "drum",
  },
  {
    prefix: "fas",
    name: "drum-steelpan",
  },
  {
    prefix: "fas",
    name: "drumstick-bite",
  },
  {
    prefix: "fas",
    name: "dumbbell",
  },
  {
    prefix: "fas",
    name: "dumpster",
  },
  {
    prefix: "fas",
    name: "dumpster-fire",
  },
  {
    prefix: "fas",
    name: "dungeon",
  },
  {
    prefix: "fas",
    name: "edit",
  },
  {
    prefix: "fas",
    name: "egg",
  },
  {
    prefix: "fas",
    name: "eject",
  },
  {
    prefix: "fas",
    name: "ellipsis-h",
  },
  {
    prefix: "fas",
    name: "ellipsis-v",
  },
  {
    prefix: "fas",
    name: "envelope",
  },
  {
    prefix: "fas",
    name: "envelope-open",
  },
  {
    prefix: "fas",
    name: "envelope-open-text",
  },
  {
    prefix: "fas",
    name: "envelope-square",
  },
  {
    prefix: "fas",
    name: "equals",
  },
  {
    prefix: "fas",
    name: "eraser",
  },
  {
    prefix: "fas",
    name: "ethernet",
  },
  {
    prefix: "fas",
    name: "euro-sign",
  },
  {
    prefix: "fas",
    name: "exchange-alt",
  },
  {
    prefix: "fas",
    name: "exclamation",
  },
  {
    prefix: "fas",
    name: "exclamation-circle",
  },
  {
    prefix: "fas",
    name: "exclamation-triangle",
  },
  {
    prefix: "fas",
    name: "expand",
  },
  {
    prefix: "fas",
    name: "expand-alt",
  },
  {
    prefix: "fas",
    name: "expand-arrows-alt",
  },
  {
    prefix: "fas",
    name: "external-link-alt",
  },
  {
    prefix: "fas",
    name: "external-link-square-alt",
  },
  {
    prefix: "fas",
    name: "eye",
  },
  {
    prefix: "fas",
    name: "eye-dropper",
  },
  {
    prefix: "fas",
    name: "eye-slash",
  },
  {
    prefix: "fas",
    name: "fan",
  },
  {
    prefix: "fas",
    name: "fast-backward",
  },
  {
    prefix: "fas",
    name: "fast-forward",
  },
  {
    prefix: "fas",
    name: "faucet",
  },
  {
    prefix: "fas",
    name: "fax",
  },
  {
    prefix: "fas",
    name: "feather",
  },
  {
    prefix: "fas",
    name: "feather-alt",
  },
  {
    prefix: "fas",
    name: "female",
  },
  {
    prefix: "fas",
    name: "fighter-jet",
  },
  {
    prefix: "fas",
    name: "file",
  },
  {
    prefix: "fas",
    name: "file-alt",
  },
  {
    prefix: "fas",
    name: "file-archive",
  },
  {
    prefix: "fas",
    name: "file-audio",
  },
  {
    prefix: "fas",
    name: "file-code",
  },
  {
    prefix: "fas",
    name: "file-contract",
  },
  {
    prefix: "fas",
    name: "file-csv",
  },
  {
    prefix: "fas",
    name: "file-download",
  },
  {
    prefix: "fas",
    name: "file-excel",
  },
  {
    prefix: "fas",
    name: "file-export",
  },
  {
    prefix: "fas",
    name: "file-image",
  },
  {
    prefix: "fas",
    name: "file-import",
  },
  {
    prefix: "fas",
    name: "file-invoice",
  },
  {
    prefix: "fas",
    name: "file-invoice-dollar",
  },
  {
    prefix: "fas",
    name: "file-medical",
  },
  {
    prefix: "fas",
    name: "file-medical-alt",
  },
  {
    prefix: "fas",
    name: "file-pdf",
  },
  {
    prefix: "fas",
    name: "file-powerpoint",
  },
  {
    prefix: "fas",
    name: "file-prescription",
  },
  {
    prefix: "fas",
    name: "file-signature",
  },
  {
    prefix: "fas",
    name: "file-upload",
  },
  {
    prefix: "fas",
    name: "file-video",
  },
  {
    prefix: "fas",
    name: "file-word",
  },
  {
    prefix: "fas",
    name: "fill",
  },
  {
    prefix: "fas",
    name: "fill-drip",
  },
  {
    prefix: "fas",
    name: "film",
  },
  {
    prefix: "fas",
    name: "filter",
  },
  {
    prefix: "fas",
    name: "fingerprint",
  },
  {
    prefix: "fas",
    name: "fire",
  },
  {
    prefix: "fas",
    name: "fire-alt",
  },
  {
    prefix: "fas",
    name: "fire-extinguisher",
  },
  {
    prefix: "fas",
    name: "first-aid",
  },
  {
    prefix: "fas",
    name: "fish",
  },
  {
    prefix: "fas",
    name: "fist-raised",
  },
  {
    prefix: "fas",
    name: "flag",
  },
  {
    prefix: "fas",
    name: "flag-checkered",
  },
  {
    prefix: "fas",
    name: "flag-usa",
  },
  {
    prefix: "fas",
    name: "flask",
  },
  {
    prefix: "fas",
    name: "flushed",
  },
  {
    prefix: "fas",
    name: "folder",
  },
  {
    prefix: "fas",
    name: "folder-minus",
  },
  {
    prefix: "fas",
    name: "folder-open",
  },
  {
    prefix: "fas",
    name: "folder-plus",
  },
  {
    prefix: "fas",
    name: "font",
  },
  {
    prefix: "fas",
    name: "football-ball",
  },
  {
    prefix: "fas",
    name: "forward",
  },
  {
    prefix: "fas",
    name: "frog",
  },
  {
    prefix: "fas",
    name: "frown",
  },
  {
    prefix: "fas",
    name: "frown-open",
  },
  {
    prefix: "fas",
    name: "funnel-dollar",
  },
  {
    prefix: "fas",
    name: "futbol",
  },
  {
    prefix: "fas",
    name: "gamepad",
  },
  {
    prefix: "fas",
    name: "gas-pump",
  },
  {
    prefix: "fas",
    name: "gavel",
  },
  {
    prefix: "fas",
    name: "gem",
  },
  {
    prefix: "fas",
    name: "genderless",
  },
  {
    prefix: "fas",
    name: "ghost",
  },
  {
    prefix: "fas",
    name: "gift",
  },
  {
    prefix: "fas",
    name: "gifts",
  },
  {
    prefix: "fas",
    name: "glass-cheers",
  },
  {
    prefix: "fas",
    name: "glass-martini",
  },
  {
    prefix: "fas",
    name: "glass-martini-alt",
  },
  {
    prefix: "fas",
    name: "glass-whiskey",
  },
  {
    prefix: "fas",
    name: "glasses",
  },
  {
    prefix: "fas",
    name: "globe",
  },
  {
    prefix: "fas",
    name: "globe-africa",
  },
  {
    prefix: "fas",
    name: "globe-americas",
  },
  {
    prefix: "fas",
    name: "globe-asia",
  },
  {
    prefix: "fas",
    name: "globe-europe",
  },
  {
    prefix: "fas",
    name: "golf-ball",
  },
  {
    prefix: "fas",
    name: "gopuram",
  },
  {
    prefix: "fas",
    name: "graduation-cap",
  },
  {
    prefix: "fas",
    name: "greater-than",
  },
  {
    prefix: "fas",
    name: "greater-than-equal",
  },
  {
    prefix: "fas",
    name: "grimace",
  },
  {
    prefix: "fas",
    name: "grin",
  },
  {
    prefix: "fas",
    name: "grin-alt",
  },
  {
    prefix: "fas",
    name: "grin-beam",
  },
  {
    prefix: "fas",
    name: "grin-beam-sweat",
  },
  {
    prefix: "fas",
    name: "grin-hearts",
  },
  {
    prefix: "fas",
    name: "grin-squint",
  },
  {
    prefix: "fas",
    name: "grin-squint-tears",
  },
  {
    prefix: "fas",
    name: "grin-stars",
  },
  {
    prefix: "fas",
    name: "grin-tears",
  },
  {
    prefix: "fas",
    name: "grin-tongue",
  },
  {
    prefix: "fas",
    name: "grin-tongue-squint",
  },
  {
    prefix: "fas",
    name: "grin-tongue-wink",
  },
  {
    prefix: "fas",
    name: "grin-wink",
  },
  {
    prefix: "fas",
    name: "grip-horizontal",
  },
  {
    prefix: "fas",
    name: "grip-lines",
  },
  {
    prefix: "fas",
    name: "grip-lines-vertical",
  },
  {
    prefix: "fas",
    name: "grip-vertical",
  },
  {
    prefix: "fas",
    name: "guitar",
  },
  {
    prefix: "fas",
    name: "h-square",
  },
  {
    prefix: "fas",
    name: "hamburger",
  },
  {
    prefix: "fas",
    name: "hammer",
  },
  {
    prefix: "fas",
    name: "hamsa",
  },
  {
    prefix: "fas",
    name: "hand-holding",
  },
  {
    prefix: "fas",
    name: "hand-holding-heart",
  },
  {
    prefix: "fas",
    name: "hand-holding-medical",
  },
  {
    prefix: "fas",
    name: "hand-holding-usd",
  },
  {
    prefix: "fas",
    name: "hand-holding-water",
  },
  {
    prefix: "fas",
    name: "hand-lizard",
  },
  {
    prefix: "fas",
    name: "hand-middle-finger",
  },
  {
    prefix: "fas",
    name: "hand-paper",
  },
  {
    prefix: "fas",
    name: "hand-peace",
  },
  {
    prefix: "fas",
    name: "hand-point-down",
  },
  {
    prefix: "fas",
    name: "hand-point-left",
  },
  {
    prefix: "fas",
    name: "hand-point-right",
  },
  {
    prefix: "fas",
    name: "hand-point-up",
  },
  {
    prefix: "fas",
    name: "hand-pointer",
  },
  {
    prefix: "fas",
    name: "hand-rock",
  },
  {
    prefix: "fas",
    name: "hand-scissors",
  },
  {
    prefix: "fas",
    name: "hand-sparkles",
  },
  {
    prefix: "fas",
    name: "hand-spock",
  },
  {
    prefix: "fas",
    name: "hands",
  },
  {
    prefix: "fas",
    name: "hands-helping",
  },
  {
    prefix: "fas",
    name: "hands-wash",
  },
  {
    prefix: "fas",
    name: "handshake",
  },
  {
    prefix: "fas",
    name: "handshake-alt-slash",
  },
  {
    prefix: "fas",
    name: "handshake-slash",
  },
  {
    prefix: "fas",
    name: "hanukiah",
  },
  {
    prefix: "fas",
    name: "hard-hat",
  },
  {
    prefix: "fas",
    name: "hashtag",
  },
  {
    prefix: "fas",
    name: "hat-cowboy",
  },
  {
    prefix: "fas",
    name: "hat-cowboy-side",
  },
  {
    prefix: "fas",
    name: "hat-wizard",
  },
  {
    prefix: "fas",
    name: "hdd",
  },
  {
    prefix: "fas",
    name: "head-side-cough",
  },
  {
    prefix: "fas",
    name: "head-side-cough-slash",
  },
  {
    prefix: "fas",
    name: "head-side-mask",
  },
  {
    prefix: "fas",
    name: "head-side-virus",
  },
  {
    prefix: "fas",
    name: "heading",
  },
  {
    prefix: "fas",
    name: "headphones",
  },
  {
    prefix: "fas",
    name: "headphones-alt",
  },
  {
    prefix: "fas",
    name: "headset",
  },
  {
    prefix: "fas",
    name: "heart",
  },
  {
    prefix: "fas",
    name: "heart-broken",
  },
  {
    prefix: "fas",
    name: "heartbeat",
  },
  {
    prefix: "fas",
    name: "helicopter",
  },
  {
    prefix: "fas",
    name: "highlighter",
  },
  {
    prefix: "fas",
    name: "hiking",
  },
  {
    prefix: "fas",
    name: "hippo",
  },
  {
    prefix: "fas",
    name: "history",
  },
  {
    prefix: "fas",
    name: "hockey-puck",
  },
  {
    prefix: "fas",
    name: "holly-berry",
  },
  {
    prefix: "fas",
    name: "home",
  },
  {
    prefix: "fas",
    name: "horse",
  },
  {
    prefix: "fas",
    name: "horse-head",
  },
  {
    prefix: "fas",
    name: "hospital",
  },
  {
    prefix: "fas",
    name: "hospital-alt",
  },
  {
    prefix: "fas",
    name: "hospital-symbol",
  },
  {
    prefix: "fas",
    name: "hospital-user",
  },
  {
    prefix: "fas",
    name: "hot-tub",
  },
  {
    prefix: "fas",
    name: "hotdog",
  },
  {
    prefix: "fas",
    name: "hotel",
  },
  {
    prefix: "fas",
    name: "hourglass",
  },
  {
    prefix: "fas",
    name: "hourglass-end",
  },
  {
    prefix: "fas",
    name: "hourglass-half",
  },
  {
    prefix: "fas",
    name: "hourglass-start",
  },
  {
    prefix: "fas",
    name: "house-damage",
  },
  {
    prefix: "fas",
    name: "house-user",
  },
  {
    prefix: "fas",
    name: "hryvnia",
  },
  {
    prefix: "fas",
    name: "i-cursor",
  },
  {
    prefix: "fas",
    name: "ice-cream",
  },
  {
    prefix: "fas",
    name: "icicles",
  },
  {
    prefix: "fas",
    name: "icons",
  },
  {
    prefix: "fas",
    name: "id-badge",
  },
  {
    prefix: "fas",
    name: "id-card",
  },
  {
    prefix: "fas",
    name: "id-card-alt",
  },
  {
    prefix: "fas",
    name: "igloo",
  },
  {
    prefix: "fas",
    name: "image",
  },
  {
    prefix: "fas",
    name: "images",
  },
  {
    prefix: "fas",
    name: "inbox",
  },
  {
    prefix: "fas",
    name: "indent",
  },
  {
    prefix: "fas",
    name: "industry",
  },
  {
    prefix: "fas",
    name: "infinity",
  },
  {
    prefix: "fas",
    name: "info",
  },
  {
    prefix: "fas",
    name: "info-circle",
  },
  {
    prefix: "fas",
    name: "italic",
  },
  {
    prefix: "fas",
    name: "jedi",
  },
  {
    prefix: "fas",
    name: "joint",
  },
  {
    prefix: "fas",
    name: "journal-whills",
  },
  {
    prefix: "fas",
    name: "kaaba",
  },
  {
    prefix: "fas",
    name: "key",
  },
  {
    prefix: "fas",
    name: "keyboard",
  },
  {
    prefix: "fas",
    name: "khanda",
  },
  {
    prefix: "fas",
    name: "kiss",
  },
  {
    prefix: "fas",
    name: "kiss-beam",
  },
  {
    prefix: "fas",
    name: "kiss-wink-heart",
  },
  {
    prefix: "fas",
    name: "kiwi-bird",
  },
  {
    prefix: "fas",
    name: "landmark",
  },
  {
    prefix: "fas",
    name: "language",
  },
  {
    prefix: "fas",
    name: "laptop",
  },
  {
    prefix: "fas",
    name: "laptop-code",
  },
  {
    prefix: "fas",
    name: "laptop-house",
  },
  {
    prefix: "fas",
    name: "laptop-medical",
  },
  {
    prefix: "fas",
    name: "laugh",
  },
  {
    prefix: "fas",
    name: "laugh-beam",
  },
  {
    prefix: "fas",
    name: "laugh-squint",
  },
  {
    prefix: "fas",
    name: "laugh-wink",
  },
  {
    prefix: "fas",
    name: "layer-group",
  },
  {
    prefix: "fas",
    name: "leaf",
  },
  {
    prefix: "fas",
    name: "lemon",
  },
  {
    prefix: "fas",
    name: "less-than",
  },
  {
    prefix: "fas",
    name: "less-than-equal",
  },
  {
    prefix: "fas",
    name: "level-down-alt",
  },
  {
    prefix: "fas",
    name: "level-up-alt",
  },
  {
    prefix: "fas",
    name: "life-ring",
  },
  {
    prefix: "fas",
    name: "lightbulb",
  },
  {
    prefix: "fas",
    name: "link",
  },
  {
    prefix: "fas",
    name: "lira-sign",
  },
  {
    prefix: "fas",
    name: "list",
  },
  {
    prefix: "fas",
    name: "list-alt",
  },
  {
    prefix: "fas",
    name: "list-ol",
  },
  {
    prefix: "fas",
    name: "list-ul",
  },
  {
    prefix: "fas",
    name: "location-arrow",
  },
  {
    prefix: "fas",
    name: "lock",
  },
  {
    prefix: "fas",
    name: "lock-open",
  },
  {
    prefix: "fas",
    name: "long-arrow-alt-down",
  },
  {
    prefix: "fas",
    name: "long-arrow-alt-left",
  },
  {
    prefix: "fas",
    name: "long-arrow-alt-right",
  },
  {
    prefix: "fas",
    name: "long-arrow-alt-up",
  },
  {
    prefix: "fas",
    name: "low-vision",
  },
  {
    prefix: "fas",
    name: "luggage-cart",
  },
  {
    prefix: "fas",
    name: "lungs",
  },
  {
    prefix: "fas",
    name: "lungs-virus",
  },
  {
    prefix: "fas",
    name: "magic",
  },
  {
    prefix: "fas",
    name: "magnet",
  },
  {
    prefix: "fas",
    name: "mail-bulk",
  },
  {
    prefix: "fas",
    name: "male",
  },
  {
    prefix: "fas",
    name: "map",
  },
  {
    prefix: "fas",
    name: "map-marked",
  },
  {
    prefix: "fas",
    name: "map-marked-alt",
  },
  {
    prefix: "fas",
    name: "map-marker",
  },
  {
    prefix: "fas",
    name: "map-marker-alt",
  },
  {
    prefix: "fas",
    name: "map-pin",
  },
  {
    prefix: "fas",
    name: "map-signs",
  },
  {
    prefix: "fas",
    name: "marker",
  },
  {
    prefix: "fas",
    name: "mars",
  },
  {
    prefix: "fas",
    name: "mars-double",
  },
  {
    prefix: "fas",
    name: "mars-stroke",
  },
  {
    prefix: "fas",
    name: "mars-stroke-h",
  },
  {
    prefix: "fas",
    name: "mars-stroke-v",
  },
  {
    prefix: "fas",
    name: "mask",
  },
  {
    prefix: "fas",
    name: "medal",
  },
  {
    prefix: "fas",
    name: "medkit",
  },
  {
    prefix: "fas",
    name: "meh",
  },
  {
    prefix: "fas",
    name: "meh-blank",
  },
  {
    prefix: "fas",
    name: "meh-rolling-eyes",
  },
  {
    prefix: "fas",
    name: "memory",
  },
  {
    prefix: "fas",
    name: "menorah",
  },
  {
    prefix: "fas",
    name: "mercury",
  },
  {
    prefix: "fas",
    name: "meteor",
  },
  {
    prefix: "fas",
    name: "microchip",
  },
  {
    prefix: "fas",
    name: "microphone",
  },
  {
    prefix: "fas",
    name: "microphone-alt",
  },
  {
    prefix: "fas",
    name: "microphone-alt-slash",
  },
  {
    prefix: "fas",
    name: "microphone-slash",
  },
  {
    prefix: "fas",
    name: "microscope",
  },
  {
    prefix: "fas",
    name: "minus",
  },
  {
    prefix: "fas",
    name: "minus-circle",
  },
  {
    prefix: "fas",
    name: "minus-square",
  },
  {
    prefix: "fas",
    name: "mitten",
  },
  {
    prefix: "fas",
    name: "mobile",
  },
  {
    prefix: "fas",
    name: "mobile-alt",
  },
  {
    prefix: "fas",
    name: "money-bill",
  },
  {
    prefix: "fas",
    name: "money-bill-alt",
  },
  {
    prefix: "fas",
    name: "money-bill-wave",
  },
  {
    prefix: "fas",
    name: "money-bill-wave-alt",
  },
  {
    prefix: "fas",
    name: "money-check",
  },
  {
    prefix: "fas",
    name: "money-check-alt",
  },
  {
    prefix: "fas",
    name: "monument",
  },
  {
    prefix: "fas",
    name: "moon",
  },
  {
    prefix: "fas",
    name: "mortar-pestle",
  },
  {
    prefix: "fas",
    name: "mosque",
  },
  {
    prefix: "fas",
    name: "motorcycle",
  },
  {
    prefix: "fas",
    name: "mountain",
  },
  {
    prefix: "fas",
    name: "mouse",
  },
  {
    prefix: "fas",
    name: "mouse-pointer",
  },
  {
    prefix: "fas",
    name: "mug-hot",
  },
  {
    prefix: "fas",
    name: "music",
  },
  {
    prefix: "fas",
    name: "network-wired",
  },
  {
    prefix: "fas",
    name: "neuter",
  },
  {
    prefix: "fas",
    name: "newspaper",
  },
  {
    prefix: "fas",
    name: "not-equal",
  },
  {
    prefix: "fas",
    name: "notes-medical",
  },
  {
    prefix: "fas",
    name: "object-group",
  },
  {
    prefix: "fas",
    name: "object-ungroup",
  },
  {
    prefix: "fas",
    name: "oil-can",
  },
  {
    prefix: "fas",
    name: "om",
  },
  {
    prefix: "fas",
    name: "otter",
  },
  {
    prefix: "fas",
    name: "outdent",
  },
  {
    prefix: "fas",
    name: "pager",
  },
  {
    prefix: "fas",
    name: "paint-brush",
  },
  {
    prefix: "fas",
    name: "paint-roller",
  },
  {
    prefix: "fas",
    name: "palette",
  },
  {
    prefix: "fas",
    name: "pallet",
  },
  {
    prefix: "fas",
    name: "paper-plane",
  },
  {
    prefix: "fas",
    name: "paperclip",
  },
  {
    prefix: "fas",
    name: "parachute-box",
  },
  {
    prefix: "fas",
    name: "paragraph",
  },
  {
    prefix: "fas",
    name: "parking",
  },
  {
    prefix: "fas",
    name: "passport",
  },
  {
    prefix: "fas",
    name: "pastafarianism",
  },
  {
    prefix: "fas",
    name: "paste",
  },
  {
    prefix: "fas",
    name: "pause",
  },
  {
    prefix: "fas",
    name: "pause-circle",
  },
  {
    prefix: "fas",
    name: "paw",
  },
  {
    prefix: "fas",
    name: "peace",
  },
  {
    prefix: "fas",
    name: "pen",
  },
  {
    prefix: "fas",
    name: "pen-alt",
  },
  {
    prefix: "fas",
    name: "pen-fancy",
  },
  {
    prefix: "fas",
    name: "pen-nib",
  },
  {
    prefix: "fas",
    name: "pen-square",
  },
  {
    prefix: "fas",
    name: "pencil-alt",
  },
  {
    prefix: "fas",
    name: "pencil-ruler",
  },
  {
    prefix: "fas",
    name: "people-arrows",
  },
  {
    prefix: "fas",
    name: "people-carry",
  },
  {
    prefix: "fas",
    name: "pepper-hot",
  },
  {
    prefix: "fas",
    name: "percent",
  },
  {
    prefix: "fas",
    name: "percentage",
  },
  {
    prefix: "fas",
    name: "person-booth",
  },
  {
    prefix: "fas",
    name: "phone",
  },
  {
    prefix: "fas",
    name: "phone-alt",
  },
  {
    prefix: "fas",
    name: "phone-slash",
  },
  {
    prefix: "fas",
    name: "phone-square",
  },
  {
    prefix: "fas",
    name: "phone-square-alt",
  },
  {
    prefix: "fas",
    name: "phone-volume",
  },
  {
    prefix: "fas",
    name: "photo-video",
  },
  {
    prefix: "fas",
    name: "piggy-bank",
  },
  {
    prefix: "fas",
    name: "pills",
  },
  {
    prefix: "fas",
    name: "pizza-slice",
  },
  {
    prefix: "fas",
    name: "place-of-worship",
  },
  {
    prefix: "fas",
    name: "plane",
  },
  {
    prefix: "fas",
    name: "plane-arrival",
  },
  {
    prefix: "fas",
    name: "plane-departure",
  },
  {
    prefix: "fas",
    name: "plane-slash",
  },
  {
    prefix: "fas",
    name: "play",
  },
  {
    prefix: "fas",
    name: "play-circle",
  },
  {
    prefix: "fas",
    name: "plug",
  },
  {
    prefix: "fas",
    name: "plus",
  },
  {
    prefix: "fas",
    name: "plus-circle",
  },
  {
    prefix: "fas",
    name: "plus-square",
  },
  {
    prefix: "fas",
    name: "podcast",
  },
  {
    prefix: "fas",
    name: "poll",
  },
  {
    prefix: "fas",
    name: "poll-h",
  },
  {
    prefix: "fas",
    name: "poo",
  },
  {
    prefix: "fas",
    name: "poo-storm",
  },
  {
    prefix: "fas",
    name: "poop",
  },
  {
    prefix: "fas",
    name: "portrait",
  },
  {
    prefix: "fas",
    name: "pound-sign",
  },
  {
    prefix: "fas",
    name: "power-off",
  },
  {
    prefix: "fas",
    name: "pray",
  },
  {
    prefix: "fas",
    name: "praying-hands",
  },
  {
    prefix: "fas",
    name: "prescription",
  },
  {
    prefix: "fas",
    name: "prescription-bottle",
  },
  {
    prefix: "fas",
    name: "prescription-bottle-alt",
  },
  {
    prefix: "fas",
    name: "print",
  },
  {
    prefix: "fas",
    name: "procedures",
  },
  {
    prefix: "fas",
    name: "project-diagram",
  },
  {
    prefix: "fas",
    name: "pump-medical",
  },
  {
    prefix: "fas",
    name: "pump-soap",
  },
  {
    prefix: "fas",
    name: "puzzle-piece",
  },
  {
    prefix: "fas",
    name: "qrcode",
  },
  {
    prefix: "fas",
    name: "question",
  },
  {
    prefix: "fas",
    name: "question-circle",
  },
  {
    prefix: "fas",
    name: "quidditch",
  },
  {
    prefix: "fas",
    name: "quote-left",
  },
  {
    prefix: "fas",
    name: "quote-right",
  },
  {
    prefix: "fas",
    name: "quran",
  },
  {
    prefix: "fas",
    name: "radiation",
  },
  {
    prefix: "fas",
    name: "radiation-alt",
  },
  {
    prefix: "fas",
    name: "rainbow",
  },
  {
    prefix: "fas",
    name: "random",
  },
  {
    prefix: "fas",
    name: "receipt",
  },
  {
    prefix: "fas",
    name: "record-vinyl",
  },
  {
    prefix: "fas",
    name: "recycle",
  },
  {
    prefix: "fas",
    name: "redo",
  },
  {
    prefix: "fas",
    name: "redo-alt",
  },
  {
    prefix: "fas",
    name: "registered",
  },
  {
    prefix: "fas",
    name: "remove-format",
  },
  {
    prefix: "fas",
    name: "reply",
  },
  {
    prefix: "fas",
    name: "reply-all",
  },
  {
    prefix: "fas",
    name: "republican",
  },
  {
    prefix: "fas",
    name: "restroom",
  },
  {
    prefix: "fas",
    name: "retweet",
  },
  {
    prefix: "fas",
    name: "ribbon",
  },
  {
    prefix: "fas",
    name: "ring",
  },
  {
    prefix: "fas",
    name: "road",
  },
  {
    prefix: "fas",
    name: "robot",
  },
  {
    prefix: "fas",
    name: "rocket",
  },
  {
    prefix: "fas",
    name: "route",
  },
  {
    prefix: "fas",
    name: "rss",
  },
  {
    prefix: "fas",
    name: "rss-square",
  },
  {
    prefix: "fas",
    name: "ruble-sign",
  },
  {
    prefix: "fas",
    name: "ruler",
  },
  {
    prefix: "fas",
    name: "ruler-combined",
  },
  {
    prefix: "fas",
    name: "ruler-horizontal",
  },
  {
    prefix: "fas",
    name: "ruler-vertical",
  },
  {
    prefix: "fas",
    name: "running",
  },
  {
    prefix: "fas",
    name: "rupee-sign",
  },
  {
    prefix: "fas",
    name: "sad-cry",
  },
  {
    prefix: "fas",
    name: "sad-tear",
  },
  {
    prefix: "fas",
    name: "satellite",
  },
  {
    prefix: "fas",
    name: "satellite-dish",
  },
  {
    prefix: "fas",
    name: "save",
  },
  {
    prefix: "fas",
    name: "school",
  },
  {
    prefix: "fas",
    name: "screwdriver",
  },
  {
    prefix: "fas",
    name: "scroll",
  },
  {
    prefix: "fas",
    name: "sd-card",
  },
  {
    prefix: "fas",
    name: "search",
  },
  {
    prefix: "fas",
    name: "search-dollar",
  },
  {
    prefix: "fas",
    name: "search-location",
  },
  {
    prefix: "fas",
    name: "search-minus",
  },
  {
    prefix: "fas",
    name: "search-plus",
  },
  {
    prefix: "fas",
    name: "seedling",
  },
  {
    prefix: "fas",
    name: "server",
  },
  {
    prefix: "fas",
    name: "shapes",
  },
  {
    prefix: "fas",
    name: "share",
  },
  {
    prefix: "fas",
    name: "share-alt",
  },
  {
    prefix: "fas",
    name: "share-alt-square",
  },
  {
    prefix: "fas",
    name: "share-square",
  },
  {
    prefix: "fas",
    name: "shekel-sign",
  },
  {
    prefix: "fas",
    name: "shield-alt",
  },
  {
    prefix: "fas",
    name: "shield-virus",
  },
  {
    prefix: "fas",
    name: "ship",
  },
  {
    prefix: "fas",
    name: "shipping-fast",
  },
  {
    prefix: "fas",
    name: "shoe-prints",
  },
  {
    prefix: "fas",
    name: "shopping-bag",
  },
  {
    prefix: "fas",
    name: "shopping-basket",
  },
  {
    prefix: "fas",
    name: "shopping-cart",
  },
  {
    prefix: "fas",
    name: "shower",
  },
  {
    prefix: "fas",
    name: "shuttle-van",
  },
  {
    prefix: "fas",
    name: "sign",
  },
  {
    prefix: "fas",
    name: "sign-in-alt",
  },
  {
    prefix: "fas",
    name: "sign-language",
  },
  {
    prefix: "fas",
    name: "sign-out-alt",
  },
  {
    prefix: "fas",
    name: "signal",
  },
  {
    prefix: "fas",
    name: "signature",
  },
  {
    prefix: "fas",
    name: "sim-card",
  },
  {
    prefix: "fas",
    name: "sink",
  },
  {
    prefix: "fas",
    name: "sitemap",
  },
  {
    prefix: "fas",
    name: "skating",
  },
  {
    prefix: "fas",
    name: "skiing",
  },
  {
    prefix: "fas",
    name: "skiing-nordic",
  },
  {
    prefix: "fas",
    name: "skull",
  },
  {
    prefix: "fas",
    name: "skull-crossbones",
  },
  {
    prefix: "fas",
    name: "slash",
  },
  {
    prefix: "fas",
    name: "sleigh",
  },
  {
    prefix: "fas",
    name: "sliders-h",
  },
  {
    prefix: "fas",
    name: "smile",
  },
  {
    prefix: "fas",
    name: "smile-beam",
  },
  {
    prefix: "fas",
    name: "smile-wink",
  },
  {
    prefix: "fas",
    name: "smog",
  },
  {
    prefix: "fas",
    name: "smoking",
  },
  {
    prefix: "fas",
    name: "smoking-ban",
  },
  {
    prefix: "fas",
    name: "sms",
  },
  {
    prefix: "fas",
    name: "snowboarding",
  },
  {
    prefix: "fas",
    name: "snowflake",
  },
  {
    prefix: "fas",
    name: "snowman",
  },
  {
    prefix: "fas",
    name: "snowplow",
  },
  {
    prefix: "fas",
    name: "soap",
  },
  {
    prefix: "fas",
    name: "socks",
  },
  {
    prefix: "fas",
    name: "solar-panel",
  },
  {
    prefix: "fas",
    name: "sort",
  },
  {
    prefix: "fas",
    name: "sort-alpha-down",
  },
  {
    prefix: "fas",
    name: "sort-alpha-down-alt",
  },
  {
    prefix: "fas",
    name: "sort-alpha-up",
  },
  {
    prefix: "fas",
    name: "sort-alpha-up-alt",
  },
  {
    prefix: "fas",
    name: "sort-amount-down",
  },
  {
    prefix: "fas",
    name: "sort-amount-down-alt",
  },
  {
    prefix: "fas",
    name: "sort-amount-up",
  },
  {
    prefix: "fas",
    name: "sort-amount-up-alt",
  },
  {
    prefix: "fas",
    name: "sort-down",
  },
  {
    prefix: "fas",
    name: "sort-numeric-down",
  },
  {
    prefix: "fas",
    name: "sort-numeric-down-alt",
  },
  {
    prefix: "fas",
    name: "sort-numeric-up",
  },
  {
    prefix: "fas",
    name: "sort-numeric-up-alt",
  },
  {
    prefix: "fas",
    name: "sort-up",
  },
  {
    prefix: "fas",
    name: "spa",
  },
  {
    prefix: "fas",
    name: "space-shuttle",
  },
  {
    prefix: "fas",
    name: "spell-check",
  },
  {
    prefix: "fas",
    name: "spider",
  },
  {
    prefix: "fas",
    name: "spinner",
  },
  {
    prefix: "fas",
    name: "splotch",
  },
  {
    prefix: "fas",
    name: "spray-can",
  },
  {
    prefix: "fas",
    name: "square",
  },
  {
    prefix: "fas",
    name: "square-full",
  },
  {
    prefix: "fas",
    name: "square-root-alt",
  },
  {
    prefix: "fas",
    name: "stamp",
  },
  {
    prefix: "fas",
    name: "star",
  },
  {
    prefix: "fas",
    name: "star-and-crescent",
  },
  {
    prefix: "fas",
    name: "star-half",
  },
  {
    prefix: "fas",
    name: "star-half-alt",
  },
  {
    prefix: "fas",
    name: "star-of-david",
  },
  {
    prefix: "fas",
    name: "star-of-life",
  },
  {
    prefix: "fas",
    name: "step-backward",
  },
  {
    prefix: "fas",
    name: "step-forward",
  },
  {
    prefix: "fas",
    name: "stethoscope",
  },
  {
    prefix: "fas",
    name: "sticky-note",
  },
  {
    prefix: "fas",
    name: "stop",
  },
  {
    prefix: "fas",
    name: "stop-circle",
  },
  {
    prefix: "fas",
    name: "stopwatch",
  },
  {
    prefix: "fas",
    name: "stopwatch-20",
  },
  {
    prefix: "fas",
    name: "store",
  },
  {
    prefix: "fas",
    name: "store-alt",
  },
  {
    prefix: "fas",
    name: "store-alt-slash",
  },
  {
    prefix: "fas",
    name: "store-slash",
  },
  {
    prefix: "fas",
    name: "stream",
  },
  {
    prefix: "fas",
    name: "street-view",
  },
  {
    prefix: "fas",
    name: "strikethrough",
  },
  {
    prefix: "fas",
    name: "stroopwafel",
  },
  {
    prefix: "fas",
    name: "subscript",
  },
  {
    prefix: "fas",
    name: "subway",
  },
  {
    prefix: "fas",
    name: "suitcase",
  },
  {
    prefix: "fas",
    name: "suitcase-rolling",
  },
  {
    prefix: "fas",
    name: "sun",
  },
  {
    prefix: "fas",
    name: "superscript",
  },
  {
    prefix: "fas",
    name: "surprise",
  },
  {
    prefix: "fas",
    name: "swatchbook",
  },
  {
    prefix: "fas",
    name: "swimmer",
  },
  {
    prefix: "fas",
    name: "swimming-pool",
  },
  {
    prefix: "fas",
    name: "synagogue",
  },
  {
    prefix: "fas",
    name: "sync",
  },
  {
    prefix: "fas",
    name: "sync-alt",
  },
  {
    prefix: "fas",
    name: "syringe",
  },
  {
    prefix: "fas",
    name: "table",
  },
  {
    prefix: "fas",
    name: "table-tennis",
  },
  {
    prefix: "fas",
    name: "tablet",
  },
  {
    prefix: "fas",
    name: "tablet-alt",
  },
  {
    prefix: "fas",
    name: "tablets",
  },
  {
    prefix: "fas",
    name: "tachometer-alt",
  },
  {
    prefix: "fas",
    name: "tag",
  },
  {
    prefix: "fas",
    name: "tags",
  },
  {
    prefix: "fas",
    name: "tape",
  },
  {
    prefix: "fas",
    name: "tasks",
  },
  {
    prefix: "fas",
    name: "taxi",
  },
  {
    prefix: "fas",
    name: "teeth",
  },
  {
    prefix: "fas",
    name: "teeth-open",
  },
  {
    prefix: "fas",
    name: "temperature-high",
  },
  {
    prefix: "fas",
    name: "temperature-low",
  },
  {
    prefix: "fas",
    name: "tenge",
  },
  {
    prefix: "fas",
    name: "terminal",
  },
  {
    prefix: "fas",
    name: "text-height",
  },
  {
    prefix: "fas",
    name: "text-width",
  },
  {
    prefix: "fas",
    name: "th",
  },
  {
    prefix: "fas",
    name: "th-large",
  },
  {
    prefix: "fas",
    name: "th-list",
  },
  {
    prefix: "fas",
    name: "theater-masks",
  },
  {
    prefix: "fas",
    name: "thermometer",
  },
  {
    prefix: "fas",
    name: "thermometer-empty",
  },
  {
    prefix: "fas",
    name: "thermometer-full",
  },
  {
    prefix: "fas",
    name: "thermometer-half",
  },
  {
    prefix: "fas",
    name: "thermometer-quarter",
  },
  {
    prefix: "fas",
    name: "thermometer-three-quarters",
  },
  {
    prefix: "fas",
    name: "thumbs-down",
  },
  {
    prefix: "fas",
    name: "thumbs-up",
  },
  {
    prefix: "fas",
    name: "thumbtack",
  },
  {
    prefix: "fas",
    name: "ticket-alt",
  },
  {
    prefix: "fas",
    name: "times",
  },
  {
    prefix: "fas",
    name: "times-circle",
  },
  {
    prefix: "fas",
    name: "tint",
  },
  {
    prefix: "fas",
    name: "tint-slash",
  },
  {
    prefix: "fas",
    name: "tired",
  },
  {
    prefix: "fas",
    name: "toggle-off",
  },
  {
    prefix: "fas",
    name: "toggle-on",
  },
  {
    prefix: "fas",
    name: "toilet",
  },
  {
    prefix: "fas",
    name: "toilet-paper",
  },
  {
    prefix: "fas",
    name: "toilet-paper-slash",
  },
  {
    prefix: "fas",
    name: "toolbox",
  },
  {
    prefix: "fas",
    name: "tools",
  },
  {
    prefix: "fas",
    name: "tooth",
  },
  {
    prefix: "fas",
    name: "torah",
  },
  {
    prefix: "fas",
    name: "torii-gate",
  },
  {
    prefix: "fas",
    name: "tractor",
  },
  {
    prefix: "fas",
    name: "trademark",
  },
  {
    prefix: "fas",
    name: "traffic-light",
  },
  {
    prefix: "fas",
    name: "trailer",
  },
  {
    prefix: "fas",
    name: "train",
  },
  {
    prefix: "fas",
    name: "tram",
  },
  {
    prefix: "fas",
    name: "transgender",
  },
  {
    prefix: "fas",
    name: "transgender-alt",
  },
  {
    prefix: "fas",
    name: "trash",
  },
  {
    prefix: "fas",
    name: "trash-alt",
  },
  {
    prefix: "fas",
    name: "trash-restore",
  },
  {
    prefix: "fas",
    name: "trash-restore-alt",
  },
  {
    prefix: "fas",
    name: "tree",
  },
  {
    prefix: "fas",
    name: "trophy",
  },
  {
    prefix: "fas",
    name: "truck",
  },
  {
    prefix: "fas",
    name: "truck-loading",
  },
  {
    prefix: "fas",
    name: "truck-monster",
  },
  {
    prefix: "fas",
    name: "truck-moving",
  },
  {
    prefix: "fas",
    name: "truck-pickup",
  },
  {
    prefix: "fas",
    name: "tshirt",
  },
  {
    prefix: "fas",
    name: "tty",
  },
  {
    prefix: "fas",
    name: "tv",
  },
  {
    prefix: "fas",
    name: "umbrella",
  },
  {
    prefix: "fas",
    name: "umbrella-beach",
  },
  {
    prefix: "fas",
    name: "underline",
  },
  {
    prefix: "fas",
    name: "undo",
  },
  {
    prefix: "fas",
    name: "undo-alt",
  },
  {
    prefix: "fas",
    name: "universal-access",
  },
  {
    prefix: "fas",
    name: "university",
  },
  {
    prefix: "fas",
    name: "unlink",
  },
  {
    prefix: "fas",
    name: "unlock",
  },
  {
    prefix: "fas",
    name: "unlock-alt",
  },
  {
    prefix: "fas",
    name: "upload",
  },
  {
    prefix: "fas",
    name: "user",
  },
  {
    prefix: "fas",
    name: "user-alt",
  },
  {
    prefix: "fas",
    name: "user-alt-slash",
  },
  {
    prefix: "fas",
    name: "user-astronaut",
  },
  {
    prefix: "fas",
    name: "user-check",
  },
  {
    prefix: "fas",
    name: "user-circle",
  },
  {
    prefix: "fas",
    name: "user-clock",
  },
  {
    prefix: "fas",
    name: "user-cog",
  },
  {
    prefix: "fas",
    name: "user-edit",
  },
  {
    prefix: "fas",
    name: "user-friends",
  },
  {
    prefix: "fas",
    name: "user-graduate",
  },
  {
    prefix: "fas",
    name: "user-injured",
  },
  {
    prefix: "fas",
    name: "user-lock",
  },
  {
    prefix: "fas",
    name: "user-md",
  },
  {
    prefix: "fas",
    name: "user-minus",
  },
  {
    prefix: "fas",
    name: "user-ninja",
  },
  {
    prefix: "fas",
    name: "user-nurse",
  },
  {
    prefix: "fas",
    name: "user-plus",
  },
  {
    prefix: "fas",
    name: "user-secret",
  },
  {
    prefix: "fas",
    name: "user-shield",
  },
  {
    prefix: "fas",
    name: "user-slash",
  },
  {
    prefix: "fas",
    name: "user-tag",
  },
  {
    prefix: "fas",
    name: "user-tie",
  },
  {
    prefix: "fas",
    name: "user-times",
  },
  {
    prefix: "fas",
    name: "users",
  },
  {
    prefix: "fas",
    name: "users-cog",
  },
  {
    prefix: "fas",
    name: "users-slash",
  },
  {
    prefix: "fas",
    name: "utensil-spoon",
  },
  {
    prefix: "fas",
    name: "utensils",
  },
  {
    prefix: "fas",
    name: "vector-square",
  },
  {
    prefix: "fas",
    name: "venus",
  },
  {
    prefix: "fas",
    name: "venus-double",
  },
  {
    prefix: "fas",
    name: "venus-mars",
  },
  {
    prefix: "fas",
    name: "vest",
  },
  {
    prefix: "fas",
    name: "vest-patches",
  },
  {
    prefix: "fas",
    name: "vial",
  },
  {
    prefix: "fas",
    name: "vials",
  },
  {
    prefix: "fas",
    name: "video",
  },
  {
    prefix: "fas",
    name: "video-slash",
  },
  {
    prefix: "fas",
    name: "vihara",
  },
  {
    prefix: "fas",
    name: "virus",
  },
  {
    prefix: "fas",
    name: "virus-slash",
  },
  {
    prefix: "fas",
    name: "viruses",
  },
  {
    prefix: "fas",
    name: "voicemail",
  },
  {
    prefix: "fas",
    name: "volleyball-ball",
  },
  {
    prefix: "fas",
    name: "volume-down",
  },
  {
    prefix: "fas",
    name: "volume-mute",
  },
  {
    prefix: "fas",
    name: "volume-off",
  },
  {
    prefix: "fas",
    name: "volume-up",
  },
  {
    prefix: "fas",
    name: "vote-yea",
  },
  {
    prefix: "fas",
    name: "vr-cardboard",
  },
  {
    prefix: "fas",
    name: "walking",
  },
  {
    prefix: "fas",
    name: "wallet",
  },
  {
    prefix: "fas",
    name: "warehouse",
  },
  {
    prefix: "fas",
    name: "water",
  },
  {
    prefix: "fas",
    name: "wave-square",
  },
  {
    prefix: "fas",
    name: "weight",
  },
  {
    prefix: "fas",
    name: "weight-hanging",
  },
  {
    prefix: "fas",
    name: "wheelchair",
  },
  {
    prefix: "fas",
    name: "wifi",
  },
  {
    prefix: "fas",
    name: "wind",
  },
  {
    prefix: "fas",
    name: "window-close",
  },
  {
    prefix: "fas",
    name: "window-maximize",
  },
  {
    prefix: "fas",
    name: "window-minimize",
  },
  {
    prefix: "fas",
    name: "window-restore",
  },
  {
    prefix: "fas",
    name: "wine-bottle",
  },
  {
    prefix: "fas",
    name: "wine-glass",
  },
  {
    prefix: "fas",
    name: "wine-glass-alt",
  },
  {
    prefix: "fas",
    name: "won-sign",
  },
  {
    prefix: "fas",
    name: "wrench",
  },
  {
    prefix: "fas",
    name: "x-ray",
  },
  {
    prefix: "fas",
    name: "yen-sign",
  },
  {
    prefix: "fas",
    name: "yin-yang",
  },
];
